/* eslint-disable react/no-danger */
import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Image from '@nubank/nuds-web/components/Image/Image';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
import styled from 'styled-components';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { useIntl } from 'react-intl';

import { useDynamicYieldValues } from '../../../../utils/dynamicYield';

import carouselItems from './carouselItems.json';

const StyledSplide = styled(Splide)`
  .splide__pagination {
    display: flex;
    justify-content: left;
    padding-top: 24px;
    padding-left: 28px;
  }

  .splide__pagination__page {
    border-radius: 12px;
    width: 8px;
    height: 8px;
    margin-right: 20px;
    background-color: ${nuDSColor('black.defaultT20')};
    
    &.is-active {
      width: 16px;
      background-color: ${nuDSColor('primary')};
    }
  }
`;

const StyledDescription = styled(Typography)`
  strong { 
    font-weight: bold;
  }
`;

const StyledImage = styled(Image)`
  max-width: 306px;
`;

function MobileSplideCarousel() {
  const { formatMessage } = useIntl();
  const { values: dynamicYieldValues } = useDynamicYieldValues();
  return (

    <Box
      background="white"
      width="100%"
      height="100%"
      display={{ xs: 'block', md: 'none' }}
    >
      <StyledSplide
        aria-label="features-account-carousel"
        options={{
          arrows: false,
          perPage: 1,
          mediaQuery: 'min',
          breakpoints: {
            600: { perPage: 2 },
          },
          padding: { right: '70px' },
        }}
      >
        {carouselItems.map(item => (
          <SplideSlide key={item.id}>
            <Box
              display="flex"
              marginLeft="24px"
              height="100%"
            >

              <Box
                display="flex"
                flexDirection="column"
              >
                {/* IMAGE */}

                <Box
                  background="linear-gradient(151deg, #9F2DEB 1.22%, #6200A3 64.1%), #F8F8FA"
                  borderRadius="12px 12px 0px 0px"
                  paddingTop={{ xs: '24px' }}
                  paddingHorizontal={{ xs: '14px' }}
                >
                  <StyledImage
                    alt={item.alt}
                    src={item.image}
                    width={{ xs: '100%' }}
                    height={{ xs: 'auto' }}
                    loading="lazy"
                    webP
                  />
                </Box>

                {/* CONTENT */}

                <Box
                  backgroundColor="#F8F8FA"
                  borderRadius="0px 0px 12px 12px"
                  paddingVertical={{ xs: '30px' }}
                  paddingHorizontal={{ xs: '32px' }}
                  minHeight="412px"
                  display="flex"
                  flexDirection="column"
                >
                  <Typography
                    variant="heading3"
                    strong
                    marginBottom="20px"
                    textAlign="left"
                    whiteSpace={{ xs: 'pre-line', md: 'nowrap' }}
                  >
                    {item.title}
                  </Typography>

                  <StyledDescription
                    variant="paragraph1"
                    whiteSpace="pre-line"
                    marginBottom="20px"
                    dangerouslySetInnerHTML={{ __html: formatMessage({ id: `carouselItem.${item.id}`, defaultMessage: item.description }, dynamicYieldValues) }}
                  />

                  <Link
                    href={item.link}
                    variant="action"
                    color="primary"
                    width="fit-content"
                  >
                    Descubre más
                  </Link>
                </Box>

              </Box>

            </Box>
          </SplideSlide>
        ))}

      </StyledSplide>
    </Box>
  );
}

export default MobileSplideCarousel;
